import React from 'react';

import type { UserShape } from './ownership-models.ts';
import { PageOwnershipByLineWithContributorsDropdown } from './PageOwnershipByLineWithContributorsDropdown/index.ts';

type PageOwnershipBylineContentProps = {
	owner: UserShape | null;
	author: UserShape;
	contributorCountWithoutOwner: number;
	testId?: string;
	analyticsSource: string;
	generatedBy?: string | null;
	/** Optional callback fired after a successful owner change. */
	onOwnerChange?: (previousOwnerId: string, newOwnerId: string) => void;
};

export const BadgeStylePageOwnershipByline = (props: PageOwnershipBylineContentProps) => {
	return <PageOwnershipByLineWithContributorsDropdown {...props} />;
};
